/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Pricedecrease1Inputs */

const he_statistics_pricedecrease1 = /** @type {(inputs: Statistics_Pricedecrease1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ירידות מחיר`)
};

const en_statistics_pricedecrease1 = /** @type {(inputs: Statistics_Pricedecrease1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price decreases`)
};

/**
* | output |
* | --- |
* | "Price decreases" |
*
* @param {Statistics_Pricedecrease1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const statistics_pricedecrease1 = /** @type {((inputs?: Statistics_Pricedecrease1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Pricedecrease1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_pricedecrease1(inputs)
	return en_statistics_pricedecrease1(inputs)
});
export { statistics_pricedecrease1 as "statistics_priceDecrease" }